// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sign_in{padding-top:18vh}.sign_in-motto{display:block;margin-top:180px;width:60vw;margin:0 auto 8vh}.sign_in-spirit{line-height:18px;font-size:18px;color:#fff;text-align:center;font-weight:lighter;letter-spacing:4px;margin-bottom:100px}.sign_in-button{width:30vw;min-width:500px;margin:0 auto;display:flex;justify-content:space-between}.sign_in-button .z-button{padding:0 40px}", ""]);
// Exports
exports.locals = {
	"PRIMARY_COLOR": "#0e6ccb"
};
module.exports = exports;
